import { useQuery } from '@tanstack/react-query'
import { Badge } from '@mui/material'
import api from '../api/client'
import { useAuthStore } from '../stores/authStore'

interface TicketsCountResponse {
  total_count: number
}

export default function TicketBadge({ children }: { children: React.ReactNode }) {
  const { user } = useAuthStore()
  const isAdmin = user?.role === 'admin' || user?.role === 'operator'

  const { data } = useQuery<TicketsCountResponse>({
    queryKey: ['ticket-badge'],
    queryFn: async () => {
      const res = await api.get('/tickets/tickets', {
        params: { page: 1, per_page: 1, status: 'open', scope: 'mine' },
      })
      return res.data
    },
    refetchInterval: 60000, // refresh every 60s
    enabled: isAdmin,
  })

  const count = data?.total_count ?? 0

  if (!isAdmin || count === 0) return <>{children}</>

  return (
    <Badge badgeContent={count > 99 ? '99+' : count} color="error" sx={{ '& .MuiBadge-badge': { fontSize: '0.7rem', height: 18, minWidth: 18 } }}>
      {children}
    </Badge>
  )
}